import { _axios } from '@/plugins/axios';

const fhirResource = '/api/v1/fhir';

export default {
  getImagingStudy: fhir_id => _axios.get(`${fhirResource}/imagingStudy/${fhir_id}`),
};
